<template>
  <div>
    <!-- Start Title -->
    <!-- <div class="d-flex mb-3">
      <h1 class="page-title">{{ $t('messages.title.request_transfer') }}</h1>
    </div> -->
    <!-- End Title -->

    <!-- Start Form -->

    <div class="row">
      <div class="col-12 col-lg-8 col-lg-offset-2">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label for="wallet">เลือกค่ายเกมส์</label>
              <select
                v-model="selectedWallet"
                class="form-control"
                id="wallet"
                placeholder="กรุณาเลือกค่ายเกมส์"
              >
                <option disabled selected>-- กรุณาเลือกค่ายเกมเพื่อดำเนินการต่อ --</option>
                <option value="PGSLOT">สล็อต PGSLOT</option>
                <option value="JOKERGAME">สล็อต JOKER GAME</option>
              </select>
            </div>
          </div>
        </div>
        
        <div
          v-if="selectedWallet === 'PGSLOT'"
          class="row"
        >
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <!-- <div :class="['card card-bank', { 'active' : chooseWallet==='SLOTMACHINE' }]" @click="setTransfer('MAIN_WALLET','SLOTMACHINE')"> -->
            <div class="card card-bank card-disable">
              <div class="card-body flex-shrink-1 card-bank-image">
              </div>
              <div class="card-body w-100 p-3 d-flex align-items-center">
                <h5 class="mb-0 d-flex" :class="['', { 'text-primary' : chooseWallet==='SLOTMACHINE' }]">ย้ายเงินไปยัง PGSLOT</h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <div :class="['card card-bank',{ 'active' : chooseWallet==='MAIN_WALLET' }]" @click="setTransfer('SLOTMACHINE','MAIN_WALLET')">
              <div class="card-body flex-shrink-1 card-bank-image">
              </div>
              <div class="card-body w-100 p-3 d-flex align-items-center">
                <h5 class="mb-0 d-flex" :class="['', { 'text-primary' : chooseWallet==='MAIN_WALLET' }]">ย้ายเงินเข้า {{getNameByKey('MAIN_WALLET')}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="selectedWallet === 'JOKERGAME'"
          class="row"
        >
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <!-- <div :class="['card card-bank', { 'active' : chooseWallet==='JOKERGAME' }]" @click="setTransfer('MAIN_WALLET','JOKERGAME')"> -->
            <div class="card card-bank card-disable">
              <div class="card-body flex-shrink-1 card-bank-image">
              </div>
              <div class="card-body w-100 p-3 d-flex align-items-center">
                <h5 class="mb-0 d-flex" :class="['', { 'text-primary' : chooseWallet==='JOKERGAME' }]">ย้ายเงินไปยัง {{getNameByKey('JOKERGAME')}}</h5>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <div :class="['card card-bank',{ 'active' : chooseWallet==='MAIN_WALLET' }]" @click="setTransfer('JOKERGAME','MAIN_WALLET')">
              <div class="card-body flex-shrink-1 card-bank-image">
              </div>
              <div class="card-body w-100 p-3 d-flex align-items-center">
                <h5 class="mb-0 d-flex" :class="['', { 'text-primary' : chooseWallet==='MAIN_WALLET' }]">ย้ายเงินเข้า {{getNameByKey('MAIN_WALLET')}}</h5>
              </div>
            </div>
          </div>
        </div>
        <input type="radio" name="transfer_wallet_to" v-model="data.to" class="hidden" v-validate="'required'"/>

        <div class="row">
          <div class="col-12 col-lg-12 text-center">
            <div v-show="errors.has('transfer_wallet_to')" class="transfer_wallet_to-error help-block text-danger">
              {{ errors.first('transfer_wallet_to') }}
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-xl-3 col-form-label">{{ $t('messages.remaining_chip') }}</label>
          <div class="col-sm-8 col-xl-7">
            <ul class="list-inline form-control-plaintext">
              <li class="list-inline-item">
                <i class="fas fa-coins mr-2 text-primary"></i><strong>{{ getCreditByKey(creditTransferDisplay) | float }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-4 col-xl-3 col-form-label">{{ $t('form.amount') }}</label>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <input v-if="chooseWallet==='SLOTMACHINE'" type="tel" maxlength="9" :class="['form-control',{ 'has-error' : errors.has('amount') }]" name="amount" v-model="data.amount" placeholder="eg. 100" autocomplete="off" v-validate="'required|numeric|between:100,'+getCreditByKey(creditTransferDisplay)+''">
            <input v-if="chooseWallet!=='SLOTMACHINE'" type="tel" maxlength="9" :class="['form-control',{ 'has-error' : errors.has('amount') }]" name="amount" v-model="data.amount" placeholder="eg. 100" autocomplete="off" v-validate="'required|numeric|between:1,'+getCreditByKey(creditTransferDisplay)+''">
            <div v-show="errors.has('amount')" class="help-block error text-danger">
              {{ errors.first('amount') }}
            </div>
          </div>
        </div>
        <div class="text-right">
          <a
            v-show="chooseWallet === 'SLOTMACHINE' && getCreditByKey(creditTransferDisplay) > 0"
            class="btn btn-info"
            role="button"
            id="transfer-play-pg-game"
          >
            เล่นเกมส์
          </a>
          <a
            v-show="chooseWallet === 'JOKERGAME' && getCreditByKey(creditTransferDisplay) > 0"
            class="btn btn-info"
            role="button"
            href="/member/games/joker"
          >
            เล่นเกมส์
          </a>
          <button class="btn btn-primary" @click="handleOnClickSubmit">{{ $t('form.transfer_wallet')}}</button>
        </div>

      </div>
    </div>
  </div>
  <!-- End Form -->
</template>

<script>
  import apiWallet from '../api/wallet'
  import {mapActions} from 'vuex'

  export default {
    name: 'request-transfer',
    props: [
      'userId',
      'masterId'
    ],
    data() {
      return {
        wallet: {},
        disallowDeposit: false,
        turnOverBalance: false,
        creditTransferDisplay: '',
        chooseWallet: '',
        data: {
          from: '',
          to: '',
          amount: ''
        },
        from: {},
        to: {},
        selectedWallet: '',
        aviafishLink: '',
      }
    },
    mounted() {
      const params = new URL(document.location).searchParams;
      const selectedWallet = params.get('wallet');
      if (selectedWallet === 'PGSLOT' || selectedWallet === 'JOKERGAME') {
        this.selectedWallet = selectedWallet;
      }
      this.loadData();
    },
    watch: {
      selectedWallet() {
        this.setTransfer('', '');
      },
    },
    methods: {
      loadData() {
        apiWallet.getWallet((response) => {
          console.log('response', response);
          this.wallet = _.get(response, 'data.myWallet')
          this.from = _.get(response, 'data.myWallet')
          this.to = _.get(response, 'data.myWallet')
          this.disallowDeposit = _.get(response, 'data.disallowDeposit')
          this.turnOverBalance = _.get(response, 'data.turnOverBalance')

          this.data.from = _.get(Object.keys(this.wallet), '[0]')
        }, (error) => {
          this.handleErrorMessage(error)
        })
      },
      handleOnClickFrom(key) {
        this.data.from = key
      },
      handleOnClickTo(key) {
        this.data.to = key
      },
      handleOnClickSubmit() {
        this.$validator.validateAll().then((result) => {
          const height = window.screen.height;
          const width = window.screen.width;
          if (result) {
            const that = this;
            apiWallet.postTransfer((response) => {
                if (that.chooseWallet === 'MAIN_WALLET') {
                  window.location = '/member/reports/transactions'
                  return;
                }
                if (that.selectedWallet === 'JOKERGAME') {
                  window.location.href = '/member/games/joker'
                }
                if (that.selectedWallet === 'PGSLOT') {
                  if ((width < 1024 && height < 768) || (width < 768 && height < 1024)) {
                    // mobile redirect;
                    const url = window.document.getElementById('transfer-play-pg-game')
                    window.location.href = url;
                  } else {
                    window.location.href = '/member/games/slotmachine/launch'
                  }
                }
              },
              (error) => {
                this.handleErrorMessage(error)
              }, this.data)
          }
        })
      },
      getNameByKey(key) {
        return _.get(this.wallet, `${key}.name`)
      },
      getCreditByKey(key) {
        return _.get(this.wallet, `${key}.chips.credit`, 0)
      },
      setTransfer(_from, _to) {
        this.data.to = _to
        this.data.from = _from
        this.chooseWallet = _to
        this.creditTransferDisplay = _from
      },
      getSuccessMessage() {
        //
      },
      handleErrorMessage(response) {
        const status = _.get(response, 'response.status')
        let message = null
        let title = this.$t('messages.error')

        switch (status) {
          case 400:
            message = _.get(response, 'response.data.message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          case 401:
            message = _.get(response, 'response.statusText', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            window.location = '/logout'
            break
          case 422:
            message = _.get(response, 'response.data.errors[0].message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          case 500:
            message = _.get(response, 'response.data.error.message', 'Something went wrong')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
          default:
            message = _.get(response, 'response.statusText', 'เกิดข้อผิดพลาด! กรุณารอซักครูเพื่อดำเินการอีกครั้ง')
            this.$notify.error({
              title: title,
              message: message,
              duration: 6000
            })
            break
        }
      },
    },
    created() {
      const that = this
      apiWallet.createAviaFishWallet(
        (response) => {
          that.aviafishLink = response.data.url;
        },
        (error) => {
          console.log(error)
          this.handleErrorMessage(error)
        },
        {}
      )
    },
  }
</script>

<style>
  .card-bank {
    cursor: pointer;
    padding: 15px 0 10px;
    text-align: center;
    border: 1px solid #efefef;
    border-radius: 3px;
    transition: background 0.25s;
    margin-bottom: 15px;
  }
  .card-disable {
    cursor: not-allowed;
    background: #d3d3d3;
  }
  .card-bank:hover {
    background: #f9f9f9;
    border-color: #e9e9e9;
  }
  .card-disable:hover {
    cursor: not-allowed;
    background: #d3d3d3;
  }
  .card-bank.active {
    background: #f9f9f9;
    border-color: green;
  }
  .u-select-none {
    user-select: none;
  }
  .bank-wrapper {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberRequestTransfer.vue